module.exports = __webpack_public_path__ + "static/media/support-team.d7e3b741.png";